<template>
  <section class="our-values-section">
    <div class="container">
      <!-- Left Side - Content -->
      <div class="values-content">
        <div class="values-text">
          <h2 class="values-title d-flex gap-3">
            <span class="text-white">{{ headerData.titlePart1 }}</span>
            <span class="title-line-2">{{ headerData.titlePart2 }}</span>
          </h2>
          <div class="values-list">
            <div 
              v-for="(value, index) in valuesList" 
              :key="index"
              class="value-item"
            >
              <span class="value-icon">{{ value.icon }}</span>
              <div class="value-content">
                <h3 class="value-title">{{ value.title }}</h3>
                <p class="value-description">{{ value.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "WhySogdoItsOurValuesComp",
  props: {
    headerData: {
      type: Object,
      required: true,
      default: () => ({
        titlePart1: "Our",
        titlePart2: "Values"
      })
    },
    valuesList: {
      type: Array,
      required: true,
      default: () => []
    },
    backgroundImage: {
      type: String,
      default: "/images/banner/banner-two.jpg"
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Our Values Section */
.our-values-section {
  min-height: 100vh;
  position: relative;
  background-image: url('~@/assets/images/banner/banner-two.jpg');
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

.values-container {
  display: flex;
  min-height: 100vh;
  position: relative;
}

.values-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 0.3) 100%);
  z-index: 1;
}

/* Content */
.values-content {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 80px 60px;
  z-index: 2;
}

.values-text {
  max-width: 600px;
  color: #fff;
}

.values-title {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 30px;
  font-family: 'Archivo', sans-serif;
}

.title-line-1 {
  display: block;
  color: #FF6B35;
  margin-bottom: 5px;
}

.title-line-2 {
  display: block;
  color: #F6EC4F;
}

.values-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-top: 40px;
}

.value-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(246, 236, 79, 0.1);
  transition: all 0.3s ease;
}

.value-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(246, 236, 79, 0.3);
  transform: translateX(10px);
}

.value-icon {
  font-size: 32px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(246, 236, 79, 0.1);
  border-radius: 50%;
  border: 2px solid rgba(246, 236, 79, 0.2);
}

.value-content {
  flex: 1;
}

.value-title {
  font-size: 20px;
  font-weight: 600;
  color: #F6EC4F;
  margin-bottom: 8px;
  font-family: 'Archivo', sans-serif;
}

.value-description {
  font-size: 16px;
  color: #fff;
  opacity: 0.8;
  line-height: 1.4;
}

/* Responsive Design */
@media (max-width: 768px) {
  .values-container {
    flex-direction: column;
  }
  
  .values-content {
    flex: 1;
    padding: 60px 40px;
  }
  
  .values-title {
    font-size: 36px;
  }
  
  .values-list {
    gap: 20px;
    margin-top: 30px;
  }
  
  .value-item {
    padding: 15px;
    gap: 15px;
  }
  
  .value-icon {
    font-size: 24px;
    width: 50px;
    height: 50px;
  }
  
  .value-title {
    font-size: 18px;
  }
  
  .value-description {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .values-content {
    padding: 40px 20px;
  }
  
  .values-title {
    font-size: 28px;
  }
  
  .values-list {
    gap: 15px;
    margin-top: 25px;
  }
  
  .value-item {
    padding: 12px;
    gap: 12px;
  }
  
  .value-icon {
    font-size: 20px;
    width: 40px;
    height: 40px;
  }
  
  .value-title {
    font-size: 16px;
  }
  
  .value-description {
    font-size: 13px;
  }
}
</style>
